module.exports = __webpack_public_path__ + "static/media/Vector.63dfc2f9.svg";